import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../../translate/translate.pipe.module';
import { SendTestEmailComponent } from './send-test-email.component';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {GenericModalModule} from '../../modal/generic-modal.module';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslatePipeModule,
        FormsModule,
        ReactiveFormsModule,
        GenericModalModule
    ],
  declarations: [SendTestEmailComponent],
  providers: [],
  exports: [SendTestEmailComponent]
})

export class SendTestEmailModule {

}
